module.exports = "{{view view.tabsView dataSource=view.zoneTabs animation=false}}"